import React from 'react';
import { Row, Col, Tooltip, Button } from 'antd';
import { FaInfoCircle } from 'react-icons/fa';
import FareBreakdownCard from '../bookingpagestbo/FareBreakdownCard';


const ConvenienceChargeTotalFareTripjack = ({
    convenienceCharge,
    flightDetails,
    calculatedFee,
    applyDiscountShow,
    discountAmountOffer,
    finalTotal,
    handleConfirmAndPay,
    skipAddons,
    handleSkipAddon,
    totalPriceBaggages,
    mealTotalAmount,
    totalAmount,
    totalAmountReturn,
    mealTotalAmountRetrun,
    totalAmountBaggageReturn,
    totalBookingPrice,
    applicableChargeData,
    totalSeatPrice,
    totalSeatsPriceReturn,
}) => {
    const fareRules = flightDetails?.flightDetails?.fareRules;
    if (!convenienceCharge) return null;

    return (
        <div className="traveller-card mt-4 px-3">
            <Row gutter={16} style={{ overflowY: 'auto', maxHeight: '420px', padding: '5px 0' }}>
                <Col xs={24}>

                    <div className='card'>
                        <div className="card-body">
                            <h3 className="mb-3 fw-bold">Payment Details</h3>
                            <ul className="price-details list-unstyled">
                                {flightDetails?.searchQuery?.paxInfo?.ADULT > 0 && (
                                    <li className="d-flex justify-content-between">
                                        <div> <span>{flightDetails.searchQuery.paxInfo.ADULT === 1 ? "Adult" : "Adults"} </span>({flightDetails.searchQuery.paxInfo.ADULT} X ₹{flightDetails?.priceBreakup?.ADULT_BF || 0})</div>
                                        <span>₹{(flightDetails?.priceBreakup?.ADULT_BF || 0) * flightDetails.searchQuery.paxInfo.ADULT}</span>
                                    </li>
                                )}

                                {flightDetails?.searchQuery?.paxInfo?.CHILD > 0 && (
                                    <li className="d-flex justify-content-between">
                                        <div><span>{flightDetails.searchQuery.paxInfo.CHILD === 1 ? "Child" : "Children"}</span> ({flightDetails.searchQuery.paxInfo.CHILD} X ₹{flightDetails?.priceBreakup?.CHILD_BF || 0})</div>
                                        <span>₹{(flightDetails?.priceBreakup?.CHILD_BF || 0) * flightDetails.searchQuery.paxInfo.CHILD}</span>
                                    </li>
                                )}

                                {flightDetails?.searchQuery?.paxInfo?.INFANT > 0 && (
                                    <li className="d-flex justify-content-between">
                                        <div><span>{flightDetails.searchQuery.paxInfo.CHILD === 1 ? "Infant" : "Infants"} </span>({flightDetails.searchQuery.paxInfo.INFANT} X ₹{flightDetails?.priceBreakup?.INFANT_BF || 0})</div>
                                        <span>₹{(flightDetails?.priceBreakup?.INFANT_BF || 0) * flightDetails.searchQuery.paxInfo.INFANT}</span>
                                    </li>
                                )}

                                <li className="d-flex justify-content-between">
                                    <span>Fee & Surcharges</span>
                                    <span>₹{Math.round(flightDetails?.priceBreakup?.ServiceTax || 0)}</span>
                                </li>


                                {(mealTotalAmount > 0 || mealTotalAmountRetrun > 0) && (
                                    <li className='d-flex justify-content-between'>
                                        Meal  <span>₹{mealTotalAmount + mealTotalAmountRetrun}</span>
                                    </li>
                                )}


                                {(totalAmount > 0 || totalAmountBaggageReturn > 0) && (
                                    <li className='d-flex justify-content-between'>
                                        Baggage <span>₹{totalAmount + totalAmountBaggageReturn}</span>
                                    </li>
                                )}

                                {console.log("totalSeatPrice", totalSeatPrice > 0 || totalSeatsPriceReturn)}
                                {/* 
                                {(totalSeatPrice > 0 || totalSeatPriceReturn > 0) && (
                                    <li className='d-flex justify-content-between'>
                                        Seats <span>₹{totalSeatPrice + totalSeatPriceReturn}</span>
                                    </li>
                                )} */}

                                {(totalSeatPrice > 0 || totalSeatsPriceReturn > 0) && (
                                    <li className='d-flex justify-content-between'>
                                        Seats <span>₹{totalSeatPrice + totalSeatsPriceReturn}</span>
                                    </li>
                                )}

                                <p className="d-flex align-items-center justify-content-between border-bottom mb-1 pb-1">
                                    <span className='d-flex justify-content-between align-items-center'>
                                        Other
                                        <Tooltip title={`${applicableChargeData?.title}`}>
                                            <FaInfoCircle className="mx-1" />
                                        </Tooltip>{""}
                                        :
                                    </span>
                                    <strong>₹ {Math.round(calculatedFee)}</strong>
                                </p>

                                {applyDiscountShow && discountAmountOffer > 0 && (
                                    <li className="d-flex justify-content-between">
                                        Discount <span className="text-danger">₹{Math.round(discountAmountOffer)}</span>
                                    </li>
                                )}
                            </ul>
                            <div className="text-center mt-3 bg-light-success p-2 rounded">
                                <h3 className="d-flex justify-content-between">
                                    Total :
                                    <span style={{ fontWeight: 'bold' }}>
                                        ₹{Math.round(
                                            !applyDiscountShow
                                                ? totalBookingPrice + calculatedFee
                                                : totalBookingPrice + calculatedFee - discountAmountOffer
                                        )}
                                    </span>
                                </h3>

                            </div>
                        </div>
                    </div>




                    <Col md={24} className='text-center'>
                        <Button
                            onClick={handleConfirmAndPay}
                            type='primary'
                            style={{ height: "42px" }}
                            className='btn btn-primary menu-block rounded mt-3'
                            aria-label="Pay now"
                        >
                            Pay Now
                        </Button>
                    </Col>



                </Col>
            </Row>
        </div >
    );
};

export default ConvenienceChargeTotalFareTripjack;
